var chunkMapping = {
	"0": [
		4645
	],
	"3": [
		4053,
		4346
	],
	"79": [
		5076
	],
	"164": [
		5161
	],
	"165": [
		5162
	],
	"168": [
		5165
	],
	"169": [
		5166
	],
	"170": [
		5167
	],
	"171": [
		5168
	],
	"172": [
		5169
	],
	"173": [
		5170
	],
	"174": [
		5171
	],
	"175": [
		5172
	],
	"176": [
		5173
	],
	"177": [
		5174
	],
	"178": [
		5175
	],
	"179": [
		5176
	],
	"180": [
		5177
	],
	"181": [
		5178
	],
	"182": [
		5179
	],
	"183": [
		5180
	],
	"184": [
		5181
	],
	"185": [
		5182
	],
	"186": [
		5183
	],
	"187": [
		5184
	]
};
var idToExternalAndNameMapping = {
	"4053": [
		"default",
		"./nuorder-components",
		3669
	],
	"4346": [
		"default",
		"./helios-components",
		3669
	],
	"4645": [
		"default",
		"./Containers",
		3579
	],
	"5076": [
		"default",
		"./OrderlessInvoices",
		3579
	],
	"5161": [
		"default",
		"./AsyncEventTracker",
		3579
	],
	"5162": [
		"default",
		"./HostWrapper",
		3579
	],
	"5165": [
		"default",
		"./CheckoutV3",
		3579
	],
	"5166": [
		"default",
		"./CheckoutConfirmation",
		3579
	],
	"5167": [
		"default",
		"./ContactCreditCards",
		3579
	],
	"5168": [
		"default",
		"./AuditDialog",
		3579
	],
	"5169": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3579
	],
	"5170": [
		"default",
		"./InvoiceDialog",
		3579
	],
	"5171": [
		"default",
		"./PaymentDueModal",
		3579
	],
	"5172": [
		"default",
		"./PaymentModal",
		3579
	],
	"5173": [
		"default",
		"./PaymentHistory",
		3579
	],
	"5174": [
		"default",
		"./PaymentConfigurations",
		3579
	],
	"5175": [
		"default",
		"./PaymentPreferences",
		3579
	],
	"5176": [
		"default",
		"./ManagePaymentProcessing",
		3579
	],
	"5177": [
		"default",
		"./MobilePaymentsWrapper",
		3579
	],
	"5178": [
		"default",
		"./PayPage",
		3579
	],
	"5179": [
		"default",
		"./Challenge",
		3579
	],
	"5180": [
		"default",
		"./ManagePaymentMethods",
		3579
	],
	"5181": [
		"default",
		"./LightspeedReports",
		3579
	],
	"5182": [
		"default",
		"./ActivateLightspeedPayments",
		3579
	],
	"5183": [
		"default",
		"./MarketingLandingPage",
		3579
	],
	"5184": [
		"default",
		"./ShippingPromotionsListContainer",
		3579
	]
};
var idToRemoteMap = {
	"4053": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3669
		}
	],
	"4346": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3669
		}
	],
	"4645": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5076": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5161": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5162": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5165": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5166": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5167": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5168": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5169": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5170": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5171": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5172": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5174": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3579
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}